export default "__VITE_ASSET__Cd$bOXMA__"